<template>
<div>
  <v-toolbar flat  v-if="selectedItems.length">
    <v-btn icon @click="removeSelected">
      <v-icon>mdi-close</v-icon>
    </v-btn>

    <v-toolbar-title>
      {{ selectedItems.length === 1 ? "1 seleccionado" : `${selectedItems.length} seleccionados` }}
    </v-toolbar-title>

    <v-divider class="mx-4" inset vertical></v-divider>

    <v-menu v-if="selectedItems.length === 1" bottom left>
      <template v-slot:activator="{ on, attrs }">
        <v-btn text v-bind="attrs" v-on="on">
          Editar
          <v-icon>mdi-chevron-down</v-icon>
        </v-btn>
      </template>

      <v-list>
        <v-list-item
          v-for="(item, i) in items"
          :key="i"
          dense
          @click="setModoEdicion(item.value, selectedItems[0])"
        >
          <v-list-item-title>{{ item.title }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>

    <v-btn v-if="selectedItems.length === 1" text @click="setEditarPrecio">
      Cambiar precios
    </v-btn>

    <v-btn v-if="selectedItems.length > 1" text @click="setUnificarProductos">
      Unificar ({{ selectedItems.length }})
    </v-btn>

    <v-spacer></v-spacer>
  </v-toolbar>

  <v-card flat>
    <v-card-text>
      <ProductoModoEdicionPanels
        v-if="productoSelectedEdit"
        :productoSelectedEdit="productoSelectedEdit"
        :modoEdicion="modoEdicion"
        @clear-mode-edition="modoEdicion = ''"
        @clear-product-selected="selectedItems = []"
      />

      <ProductoUnificarProductosPanel
        v-if="isUnificarProductos"
        :productosSeleccionados="selectedItems"
        @unificacionExitosa="handleUnificacion"
        @clear-product-selected="removeSelected"
      />

      <ProductosActualizarPrecios
        v-if="selectedItems.length === 1 && isEditarPrecio"
        :productoSeleccionado="selectedItems[0]"
        @unificacionExitosa="handleUnificacion"
      />
    </v-card-text>
  </v-card>

  <product-list-item
    v-for="item in productos"
    :key="item.id"
    :item="item"
    :selected="selectedItems.some(p => p.id === item.id)"
    @change="val => onItemSelected(item, val)"
  />
</div>

</template>

<script>
import { mapState } from "vuex";
import ProductoLayoutList from "./ProductoLayoutList.vue";
import ProductListItem from "@/components/producto/listar/ProductoListItem.vue";

import ProductoUnificarProductosPanel from "@/views/producto/ProductoUnificarProductosPanel.vue";

import ProductosActualizarPrecios from "@/components/producto/gestion/ProductosActualizarPrecios.vue";

import ProductoModoEdicionPanels from "@/views/producto/gestion/ProductoModoEdicionPanels.vue";

export default {
  name: "productos.list.table",
  components: {
    ProductoLayoutList,
    ProductListItem,
    ProductoUnificarProductosPanel,
    ProductosActualizarPrecios,
    ProductoModoEdicionPanels,
  },
  props: {
    productos: {
      type: Array,
      required: true,
      default: () => [],
    },
    verBuscador: {
      type: Boolean,
      default: true,
    },
  },
  data: () => ({
    selectedItems: [],
    dialogSucursales: {
      visible: false,
      sucursales: [],
    },
    menuOpen: false,
    search: "",
    openSearch: false,
    loading: false,
    filtros: null,
    selectedItem: false,
    isUnificarProductos: false,
    isEditarPrecio: false,
  }),
  computed: {
    ...mapState("sucursales", ["configuracion"]),
    headers() {
      if (this.configuracion.productoInventario) {
        return [
          {
            text: "Catálogo",
            value: "descripcion_global",
            align: "start",
            width: "300px",
          },
          {
            text: "Producto",
            value: "descripcion_comercial",
            align: "start",
            width: "300px",
          },
          {
            text: "Precio de venta sugerido",
            value: "precio_venta_sugerido",
            align: "center",
          },
          {
            text: "Sucursales asignadas",
            value: "sucursales_compartidas",
            align: "center",
          },
        ];
      } else {
        return [
          { text: "Producto", value: "descripcion", align: "center" },
          { text: "Marca", value: "marca.nombre", align: "center" },
          { text: "Proveedor", value: "proveedor.nombre", align: "center" },
          { text: "P. Costo", value: "precioCosto", align: "center" },
          { text: "P. Venta", value: "precioVenta", align: "center" },
          { text: "Ganancia", value: "ganancia", align: "center" },
          { text: "IVA", value: "iva", align: "center" },
        ];
      }
    },
  },
  methods: {
    setEditarPrecio() {
      this.isEditarPrecio = !this.isEditarPrecio;
    },
    setUnificarProductos() {
      this.isUnificarProductos = !this.isUnificarProductos;
    },
    onItemSelected(item, isSelected) {
      const index = this.selectedItems.findIndex((p) => p.id === item.id);
      if (isSelected && index === -1) {
        this.selectedItems.push(item);
      } else if (!isSelected && index !== -1) {
        this.selectedItems.splice(index, 1);
      }
      this.$emit("process-productos-selected", this.selectedItems);
    },

    removeSelected() {
      this.selectedItems = [];
      this.$emit("remove-selected");
    },

    abrirDialogSucursales(item) {
      this.dialogSucursales.sucursales = item.sucursales_compartidas;
      this.dialogSucursales.visible = true;
    },

    mostrarInfo(producto) {
      const uuid_empresa = this.$route.params.uuid_empresa;
      this.$router.push({
        name: "productoEmpresaDetalle",
        params: { uuid_empresa: uuid_empresa, id_producto: producto.id },
      });
    },

    selectItem(item) {
      if (!this.menuOpen) this.selectedItem = item;
    },

    unSelectItem() {
      if (!this.menuOpen) this.selectedItem = false;
    },

    cleanSelected() {
      this.selectedItems = [];
    },

    getColor(producto) {
      const cantidadstock = parseInt(producto.cantidadstock);
      const stockmin = parseInt(producto.stockmin);
      const stockmax = parseInt(producto.stockmax);
      const stockLimiteAprobado = stockmin + stockmin * 0.2;

      if (cantidadstock > stockLimiteAprobado) return "green";
      else if (cantidadstock > stockmin) return "orange";
      else return "red";
    },

    toggleAll() {
      if (this.selectedItems.length) {
        this.selectedItems = [];
      } else {
        this.selectedItems = [...this.productos];
      }
      this.$emit("process-productos-selected", this.selectedItems);
    },

    verificarCantidadSeleccionada() {
      if (this.selectedItems.length === 0) {
        this.$updateBus.$emit("showSnackBar", {
          show: true,
          button: false,
          color: "warning",
          text: "Debe seleccionar un producto",
          icon: "new_releases",
          timeout: 3000,
        });
        return false;
      }
      return true;
    },

    reset() {
      this.$refs.form?.reset();
    },
  },

  watch: {
    productos: {
      immediate: true,
      deep: true,
      handler(newArray, oldArray) {
        if (newArray.length !== oldArray.length) {
          this.selectedItems = [];
        }
      },
    },
  },
};
</script>

<style>
/* tus estilos CSS no han sido modificados */
</style>
